module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedi",
    attrs: {
      "id": "ch00_fm05_dedi"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("Dedicated to the ones")]), _vm._v(" "), _c('p', {
    staticClass: "dedi1"
  }, [_vm._v("Who in the struggle for a more equal and just world")]), _vm._v(" "), _c('p', {
    staticClass: "dedi1"
  }, [_vm._v("Face the unmitigated mutations of colonial and neoliberal discourses")]), _vm._v(" "), _c('p', {
    staticClass: "dedi1"
  }, [_vm._v("Like infections that wear you out")]), _vm._v(" "), _c('p', {
    staticClass: "dedi1"
  }, [_vm._v("The best among us")]), _vm._v(" "), _c('p', {
    staticClass: "dedi1"
  }, [_vm._v("With the guise of care that protects the Self-same.")]), _vm._v(" "), _c('p', {
    staticClass: "dedi1"
  }, [_vm._v("You watch in disgust, sickened")]), _vm._v(" "), _c('p', {
    staticClass: "dedi1"
  }, [_vm._v("But know better")]), _vm._v(" "), _c('p', {
    staticClass: "dedi1"
  }, [_vm._v("That nothing could wipe out your queer spirit")]), _vm._v(" "), _c('p', {
    staticClass: "dedi1"
  }, [_vm._v("Or the labor of your kind")]), _vm._v(" "), _c('p', {
    staticClass: "dedi1"
  }, [_vm._v("In the solidarity of our minds."), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4831d95d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm05_dedi.vue
// module id = 72
// module chunks = 0